(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.DeleteDialog = (function(superClass) {
    extend(DeleteDialog, superClass);

    function DeleteDialog() {
      return DeleteDialog.__super__.constructor.apply(this, arguments);
    }

    DeleteDialog.prototype.init = function() {
      this.layoutUrl = null;
      this.layoutSource = $('.delete-dialog');
      this.classes = 'small_dialog';
      if (this.deleteTitle == null) {
        this.deleteTitle = '';
      }
      if (this.deleteMessage == null) {
        this.deleteMessage = 'this item';
      }
      if (this.buttonText == null) {
        this.buttonText = '';
      }
      if (this.deleteExtraMessage == null) {
        this.deleteExtraMessage = '';
      }
      if (this.savingText == null) {
        this.savingText = '';
      }
      if (this.savedText == null) {
        this.savedText = '';
      }
      if (this.deleteItemID == null) {
        this.deleteItemID = null;
      }
      if (this.override_title == null) {
        this.override_title = false;
      }
      if (this.override_message == null) {
        this.override_message = false;
      }
      if (this.override_btnText == null) {
        this.override_btnText = false;
      }
      if (this.override_savingText == null) {
        this.override_savingText = false;
      }
      return this.createDialog();
    };

    DeleteDialog.prototype.afterLoadLayout = function(selector) {
      var ths;
      if (this.override_title) {
        selector.find('.delete-title').html(this.deleteTitle);
      } else {
        selector.find('.delete-title').html('Delete ' + this.deleteTitle);
      }
      if (this.override_message) {
        selector.find('.delete-message').html(this.deleteMessage);
      } else {
        selector.find('.delete-message').html('Are you sure you want to delete ' + this.deleteMessage);
      }
      if (this.override_btnText) {
        selector.find('.save-btn').html(this.buttonText);
      }
      if (this.override_savingText) {
        this.savingBtnMsg = this.savingText;
        this.savedBtnMsg = this.savedText;
      }
      selector.find('.delete-item-id').val(this.deleteItemID);
      selector.find('.delete-extra-message').html(this.deleteExtraMessage);
      this.openDialog();
      ths = this;
      return this.submitAction = (function(_this) {
        return function() {
          return _this.save('Deleting...');
        };
      })(this);
    };

    return DeleteDialog;

  })(DialogHandler);

}).call(this);
